/** Token suffixes are relative to the token subject's home organization. */
export function excludedOrganizationRefs(user) {
  const home = user?.["custom:orgId"] || user?.organizations?.[0]?.id;
  if (!home) return [];
  let values = user?.["custom:excludedOrgIds"] || [];
  try { if (typeof values === "string") values = JSON.parse(values); } catch { return [home]; }
  if (!Array.isArray(values) || values.some(value => typeof value !== "string" || !value.trim())) return [home];
  return [...new Set(values.map(value => `${home}.${value}`))];
}

export function isExcludedOrganization(id, exclusions) {
  return exclusions.some(excluded => id === excluded || id?.startsWith(`${excluded}.`));
}

export function categoryOption(category) {
  return { value:category.serviceCategoryId, name:category.name,
    organizationRef:category.organizationRef, organizationName:category.organizationName || category.organizationRef };
}
